import { get } from 'lodash';
import { PAGE_CAR_TYPES, CAR_TYPES, PAGE_CAR_SUBTYPES } from 'site-modules/shared/constants/upper-funnel/car-types';
import { CmsModel } from 'client/data/models/cms';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { getModelState } from 'client/data/luckdragon/model';
import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';
import { parseContent } from 'client/data/cms/content';

const carTypes = Object.values(PAGE_CAR_TYPES);
const carSubtypes = Object.values(PAGE_CAR_SUBTYPES);

export const routes = [
  {
    path: `/suv/luxury/`,
    exact: true,
    enableLooseEtag: true,
    preload: (_, store) => {
      const preloader = new ModelPreloader(store);

      preloader.resolve(`content["/car-news/best-luxury-suvs-2025"]`, CmsModel);

      return preloader.load();
    },
    page: getLoadablePage((_, store) => {
      const modelState = getModelState(store.getState());
      const pageParams = {
        articleCategory: 'car-news',
        splat: undefined,
        articleId: 'best-luxury-suvs-2025',
        ext: 'html',
      };
      const content = parseContent(modelState.get(`content["/car-news/best-luxury-suvs-2025"]`, CmsModel));
      const heroPhoto = get(content.child('hero-content').links(), [0], '');
      if (heroPhoto) {
        return import(
          /* webpackChunkName: "research-type-article" */ '../../editorial/pages/research-article/research-type/research-type-definition'
        ).then(page => page.default({ ...pageParams, chunkName: 'research-type-article' }));
      }

      return import(
        /* webpackChunkName: "research-default-article" */ '../../editorial/pages/research-article/research-default/research-default-definition'
      ).then(page => page.default({ ...pageParams, chunkName: 'research-default-article' }));
    }),
  },
  {
    path: `/:type(${carTypes.join('|')})/:subtype(${carSubtypes.join('|')})`,
    exact: true,
    enableLooseEtag: true,
    page: getLoadablePage(({ type, subtype }) =>
      import(/* webpackChunkName: "car_subtype" */ '../pages/subtype/subtype-definition').then(page =>
        page.default({
          type: type === PAGE_CAR_TYPES.ELECTRIC ? CAR_TYPES.ELECTRIC : type,
          subtype,
        })
      )
    ),
    chunkName: 'car_subtype',
  },
];
